import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../_models';
import { environment } from 'src/environments/environment';



@Injectable({ providedIn: 'root' })

export class AccountService {
    private userSubject: BehaviorSubject<any>;
    public user: Observable<User | null>;

    constructor(
        private router: Router,
        private http: HttpClient
    ) {
        this.userSubject = new BehaviorSubject( null );
        this.user = this.userSubject.asObservable();
    }

    public getUser(){
        if( this.userSubject.value != null){
            return this.userSubject;
        }
        return this.http.get<User>(`${environment.apiUrl}refresh`)
            .pipe(map((data:any) => {
                localStorage.setItem('user', JSON.stringify(data.user));
                this.userSubject.next(data.user);
                return data.user;
            }));
    }

    public refreshUser(){
        return this.http.get<User>(`${environment.apiUrl}refresh`)
            .pipe(map((data:any) => {
                localStorage.setItem('user', JSON.stringify(data.user));
                this.userSubject.next(data.user);
                return data.user;
            }));
    }
    public get userDetails() {
        return this.userSubject.value;
    }

    login(email: string, password: string) {


        return this.http.post<User>(`${environment.apiUrl}login`, { email: email, password: password })
            .pipe(map(user => {

                localStorage.setItem('user', JSON.stringify(user));
                localStorage.setItem('authToken', user.token || '');
                this.userSubject.next(user);

            }));
    }

    resetPassword(email: string) {
        return this.http.post<User>(`${environment.apiUrl}reset`, { email: email })
            .pipe(map(message => {
                return message;
            }));
    }

    changePassword(resetCode: string, newPassword: string, confirmPassword: string) {
        return this.http.post<User>(`${environment.apiUrl}updatepass`, { code: resetCode, password: newPassword, repassword: confirmPassword })
            .pipe(map(message => {
                return message;
            }));
    }

    logout(returnUrl = '') {
        const token = this.userDetails?.token || localStorage.getItem('authToken') || '';

        localStorage.removeItem('user');
        localStorage.removeItem('authToken');
        this.userSubject.next(null);

        const queryParams = returnUrl ? { returnUrl } : undefined;
        this.router.navigate(['/login'], { queryParams });

        if (token) {
            this.http.get<any>(`${environment.apiUrl}logout`, {
                headers: { Authorization: `Bearer ${token}` }
            }).subscribe({ error: () => {} });
        }
    }
}